<template>
    <section class="section has-background-info">
        <div class="container is-max-desktop">
            <div class="columns is-multiline">
                <div class="column is-8 is-full-touch my-4">
                    <h4 class="mb-3">Escribe el servicio que buscas:</h4>
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <DesktopSearchInput 
                                :value="searchText"
                                @input="handleInputAndClear"
                                @search="handleSearch"
                                @move-down="moveDown"
                                @move-up="moveUp"
                                ref="desktopInput"
                            />
                            <MobileSearchInput 
                                :value="searchText"
                                @input="handleInputAndClear"
                                @search="handleSearch"
                                @move-down="moveDown"
                                @move-up="moveUp"
                                ref="mobileInput"
                            />

                            <div v-if="showSuggestions && suggestions.length > 0" class="suggestions-container">
                                <DesktopSuggestions 
                                    :suggestions="suggestions"
                                    :selected-index="selectedIndex"
                                    :total-suggestions="totalSuggestions"
                                    @select="selectSuggestion"
                                    @mouseover="handleMouseOver"
                                    @show-all="handleShowAllResults"
                                />
                                <MobileSuggestions 
                                    :suggestions="suggestions"
                                    :selected-index="selectedIndex"
                                    :total-suggestions="totalSuggestions"
                                    @select="selectSuggestion"
                                    @mouseover="handleMouseOver"
                                    @show-all="handleShowAllResults"
                                />
                            </div>
                        </div>

                        <p class="control is-hidden-touch">
                            <b-button type="is-primary" class="btn-sm is-height-100" label="Buscar"
                                @click="handleSearch" />
                        </p>
                    </div>
                    <div class="cont-btn is-hidden-desktop">
                        <button type="button" class="button is-primary is-pulled-right"
                            @click="handleSearch">Buscar</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import DesktopSuggestions from './DesktopSuggestions.vue'
import MobileSuggestions from './MobileSuggestions.vue'
import DesktopSearchInput from './DesktopSearchInput.vue'
import MobileSearchInput from './MobileSearchInput.vue'

export default {
    name: 'SearchBox',
    components: {
        DesktopSuggestions,
        MobileSuggestions,
        DesktopSearchInput,
        MobileSearchInput
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        suggestions: {
            type: Array,
            default: () => []
        },
        showSuggestions: {
            type: Boolean,
            default: false
        },
        totalSuggestions: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            searchText: '',
            selectedIndex: -1
        }
    },
    methods: {
        handleInputAndClear(value) {
            this.handleInput(value); // Tu función original

            // Si el valor está vacío, emitir evento reset
            if (value === '' || value === null) {
                this.$emit('reset');
            }
        },
        handleInput(value) {
            this.searchText = value;
            this.selectedIndex = -1;
            this.$emit('autocomplete', value);
        },
        handleSearch() {
            if (this.selectedIndex >= 0 && this.suggestions[this.selectedIndex]) {
                this.selectSuggestion(this.suggestions[this.selectedIndex]);
            } else {
                this.$emit('search', this.searchText);
            }
        },
        handleShowAllResults() {
            this.selectedIndex = -1;
            this.handleSearch();
        },
        selectSuggestion(suggestion) {
            this.searchText = suggestion.nombre;
            this.$emit('input', suggestion.nombre);
            this.$emit('select-suggestion', suggestion);
            this.$emit('search', suggestion.nombre);
        },
        moveDown() {
            if (this.selectedIndex < this.suggestions.length - 1) {
                this.selectedIndex++;
            }
        },
        moveUp() {
            if (this.selectedIndex > 0) {
                this.selectedIndex--;
            }
        },
        handleMouseOver(index) {
            this.selectedIndex = index;
        }
    },
    watch: {
        value(newVal) {
            this.searchText = newVal;
        }
    },
    created() {
        // Asegurarnos de que value tenga un valor inicial
        if (this.value === undefined) {
            this.$emit('input', '');
        }
    },
    mounted() {
        // Cerrar sugerencias al hacer clic fuera del componente
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.$emit('close-suggestions');
            }
        });
    },
    beforeDestroy() {
        // Limpiar el event listener cuando el componente se destruye
        document.removeEventListener('click', this.handleClickOutside);
    }
};
</script>

<style scoped>
.suggestions-container {
    position: absolute;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    background: white;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    margin-top: 4px;
    z-index: 1000;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
}

:deep(.suggestion-item) {
    padding: 0.5rem 1rem;
    cursor: pointer;
}

:deep(.suggestion-item:hover),
:deep(.suggestion-item.is-active) {
    background-color: #0F69C4;
    color: white;
}

.field {
    position: relative;
}

.control.is-expanded {
    position: relative;
}

:deep(.show-all-link-container) {
    border-top: 1px solid #dbdbdb;
    padding: 0.5rem 1rem;
    background: #fff;
}

</style>